import { render, staticRenderFns } from "./TemplateDesign.vue?vue&type=template&id=8ada490e&scoped=true&"
import script from "./TemplateDesign.vue?vue&type=script&lang=js&"
export * from "./TemplateDesign.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDesign.vue?vue&type=style&index=0&id=8ada490e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ada490e",
  null
  
)

export default component.exports